import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
}

export function Skeleton({ width = '100%', height = '16px', borderRadius }: SkeletonProps) {
  return (
    <div
      class={styles.skeleton}
      style={{ width, height, borderRadius: borderRadius ?? 'var(--st-radius-sm)' }}
    />
  );
}
